// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeSettingManagement_main__eWEj0 {
    position: relative;
    width: 100%;
    height: 100%;
}

.CategorizeSettingManagement_header__oOU2e {
    display: flex;
    justify-content: space-between;
    height: 35px;
    margin-bottom: 25px;
}

.CategorizeSettingManagement_title__v3czB {
    font-size: 30px;
}

.CategorizeSettingManagement_container__EREuW {
    width: 100%;
    height: calc(100% - 60px);
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.CategorizeSettingManagement_container_top__hW6Je {
    width: 100%;
    height: 40%;
}

.CategorizeSettingManagement_container_bottom__azfv7 {
    width: 100%;
    height: 60%;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeSettingManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf","sourcesContent":[".main {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    height: calc(100% - 60px);\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.container_top {\n    width: 100%;\n    height: 40%;\n}\n\n.container_bottom {\n    width: 100%;\n    height: 60%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CategorizeSettingManagement_main__eWEj0`,
	"header": `CategorizeSettingManagement_header__oOU2e`,
	"title": `CategorizeSettingManagement_title__v3czB`,
	"container": `CategorizeSettingManagement_container__EREuW`,
	"container_top": `CategorizeSettingManagement_container_top__hW6Je`,
	"container_bottom": `CategorizeSettingManagement_container_bottom__azfv7`
};
export default ___CSS_LOADER_EXPORT___;
